import useTealium from 'src/hooks/useTealium';
import useTooltipTimer from 'src/hooks/useTooltipTimer';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
export const useTooltipTracking = (options) => {
    const { trackEvent } = useTealium();
    const { delay = 5000 } = options;
    const { handleTooltipOpen, handleTooltipClose } = useTooltipTimer({ delay });
    const trackTooltipHover = (eventName) => () => {
        handleTooltipOpen({
            event_action: TEALIUM_EVENT.EVENT_ACTION.TOOLTIP_HOVER,
            event_type: options.eventType,
            event_name: eventName
        });
    };
    const trackTooltipClick = (eventName) => () => {
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.TOOLTIP_CLICK,
            event_type: options.eventType,
            event_name: eventName
        });
    };
    return {
        trackTooltipHover,
        trackTooltipClick,
        handleTooltipClose
    };
};
